module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "registerAuthModalData"
  }, [_c('h1', {
    staticClass: "registerAuthModalData__header"
  }, [_vm._v("\n    Для добавления модуля в новую программу необходимо авторизоваться. Если у\n    вас еще нет учетной записи, вы можете зарегистрироваться\n  ")]), _c('AppButtonNew', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": _vm.buttonRegisterClick
    }
  }, [_vm._v("Регистрация")]), _c('AppButtonNew', {
    on: {
      "click": _vm.buttonAuthClick
    }
  }, [_vm._v("Войти")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82863748","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/modules/register_auth_modal/RegisterAuthModal.vue
// module id = 45fbbb249afc97530dc1
// module chunks = 7